import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './FeaturedProducts.css';

// --- Imports pour Swiper ---
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, A11y, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// --- Imports pour les fonctionnalités et les VRAIES DONNÉES ---
import { useFavorites } from '../../../context/FavoritesContext';
import { useCart } from '../../../context/CartContext';
import pb from '../../../services/pocketbase'; // Import de PocketBase

function FeaturedProducts() {
  const { favorites, toggleFavorites } = useFavorites();
  const { addToCart } = useCart();
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFeaturedProducts = async () => {
      try {
        const allProducts = await pb.collection('products').getFullList({
          filter: 'is_sold = false',
        });

        // Mélange le tableau des produits (algorithme de Fisher-Yates)
        const shuffled = [...allProducts].sort(() => 0.5 - Math.random());
        
        // Sélectionne les 5 premiers produits
        setFeaturedProducts(shuffled.slice(0, 8));
      } catch (error) {
        console.error("Erreur lors de la récupération des produits populaires:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchFeaturedProducts();
  }, []);

  return (
    <section className="featured-products-section">
      <h2 className="section-title">Nos Créations du Moment</h2>

      {loading ? (
        <p>Chargement des créations...</p>
      ) : (
      <Swiper
        modules={[Navigation, Pagination, A11y, Autoplay]}
        spaceBetween={30}
        loop={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        navigation
        pagination={{ clickable: true }}
        className="product-swiper"
        breakpoints={{
          640: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        }}
      >
        {featuredProducts.map(produit => {
          const isFavorited = favorites.some(item => item.id === produit.id);
          const imageUrl = produit.image && produit.image.length > 0 
            ? pb.files.getURL(produit, produit.image[0]) 
            : '/placeholder.png'; // Fallback image

          return (
            <SwiperSlide key={produit.id}>
              <Link to={`/catalogue/produit/${produit.slug}`} className="product-card-link">
                <div className="product-card">
                  <div className="product-image-wrapper">
                    <img src={imageUrl} alt={produit.name} className="product-image" />
                    <button 
                      className={`add-to-favorites-btn ${isFavorited ? 'favorited' : ''}`}
                      onClick={(e) => { e.preventDefault(); toggleFavorites(produit); }}
                      aria-label="Ajouter aux favoris"
                    >
                      <svg viewBox="0 0 24 24"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>
                    </button>
                  </div>
                  <div className="product-info">
                    <h3 className="product-name">{produit.name}</h3>
                    <p className="product-price">{produit.price ? `${produit.price.toFixed(2)} €` : 'Prix sur demande'}</p>
                    <div className="product-stock">
                      {produit.is_unique ? 'Pièce unique' : (produit.stock > 0 ? `Stock: ${produit.stock}` : 'Rupture de stock')}
                    </div>
                    <button 
                      className="add-to-cart-btn" 
                      onClick={(e) => { e.preventDefault(); addToCart(produit); }}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>
                      Ajouter au panier
                    </button>
                  </div>
                </div>
              </Link>
            </SwiperSlide>
          );
        })}
      </Swiper>
      )}

      <Link to="/catalogue" className="see-all-link">Voir tout le catalogue</Link>
    </section>
  );
}

export default FeaturedProducts;